<template>
  <div>
    <v-data-table
      v-if="!isMobile"
      :headers="getHeaders"
      @page-count="pageCount = $event"
      :items="categories"
      hide-default-footer
      disable-sort
      class="standard-table pripoistenie"
    >
      <template v-slot:[`item.display`]="{ item }">
        <span style="font-size: 16px; font-weight: 700;" :class="item.required ? 'text-required' : ''">
          {{ item.display }}
        </span>
      </template>

      <template v-slot:[`item.children`]="{ item }">
        <v-autocomplete
          :key="item.combo_key"
          :items="item.children"
          placeholder=""
          label="Zvoľte typ"
          class="dynamic-input-control error--text--top-14"
          outlined
          hide-details
          item-text="displayMember"
          item-value="valueMember"
          v-model="item.value"
          clearable
          @change="update(item)"
          :class="{
            required: item.required,
            readonly: item.readonly,
          }"
          :error-messages="!item.isValidate && item.isDirty ? 'Toto pole je povinné!' : ''"
          :disabled="item.readonly"
          :readonly="item.readonly"
        />
      </template>
      <template v-slot:[`item.price`]="{ item }">
        <span style="font-size: 16px;">{{ item.price ? item.price : null }}</span>
      </template>
      <template v-slot:footer>
        <v-divider></v-divider>
      </template>
    </v-data-table>

    <div v-else v-for="(item, index) in categories" :key="item.valueMember">
        <v-row style="font-size: 16px;">
          <v-col cols="7" style="font-weight: 700;" class="text-required">
            {{ item.display }}
          </v-col>
          <v-col cols="5" style="text-align: right;" v-if="!jeOlfs">
            {{ item.price ? item.price : null }}
          </v-col>
        </v-row>
        <v-autocomplete
          :key="item.combo_key"
          :items="item.children"
          placeholder=""
          label="Zvoľte typ"
          class="dynamic-input-control error--text--top-14"
          outlined
          hide-details
          item-text="displayMember"
          item-value="valueMember"
          v-model="item.value"
          clearable
          @change="update(item)"
          :class="{
            required: item.required,
            readonly: item.readonly,
          }"
          :error-messages="!item.isValidate && item.isDirty ? 'Toto pole je povinné!' : ''"
          :disabled="item.readonly"
          :readonly="item.readonly"
        />
        <v-row v-if="index != [categories.length - 1]" class="mt-3">
          <v-divider></v-divider>
        </v-row>
    </div>
  </div>
</template>
<script>
import ButtonGroup from '../basic/ButtonGroup.vue';
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';
import Utils from '../../plugins/utils';
import { wizardMixin } from '../../mixins/wizardMixin.js';

export default {
  mixins: [dynamicControlMixin, wizardMixin],
  components: { ButtonGroup },
  props: {
    jeOlfs: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      categories: [],
      headers: [
        { text: 'Kategória', value: 'display' },
        { text: 'Pripoistenie', value: 'children', width: 350 },
        { text: 'Suma', value: 'price', width: 120 },
      ],
    };
  },
  computed:{
    getHeaders(){
      if(this.jeOlfs){
        return this.headers.filter(h => h.value !== 'price');
      }else{
        return this.headers;
      }
    }
  },
  methods: {
    readData(config, data) {
      //console.log('pripoistenie readData config', config);
      //console.log('pripoistenie readData config', data);

      let controlValues = [];
      if (config.controlValue !== null && config.controlValue !== undefined)
        controlValues = config.controlValue.split(',').map(x => +x);

      this.initComplete = true;
      let categoriesList = Utils.groupBy(
        data,
        datum => datum.id_category,
        datum => datum.category
      );
      this.categories = categoriesList.map(c => {
        return {
          key: c.key,
          display: c.display,
          children: c.children,
          combo_key: Math.random().toString(36).substring(2, 7),
          required: c.children[0]?.is_required ? c.children[0]?.is_required : false,
          isValidate: c.children[0]?.is_required
            ? this.getComboValue(c.children, controlValues) != null
            : true,
          isDirty: false,
          not_set: c.children[0]?.not_set ? true : false,
          readonly: this.pripad.predmetZamknuty ? true : c.children[0]?.is_enabled ? false : true,
          price: this.getPrice(c.children, controlValues),
          value: this.getComboValue(c.children, controlValues),
        };
      });
      //console.log(this.categories);
    },
    getComboValue(comboChildren, controlValues) {
      return comboChildren.filter(ch => controlValues.includes(ch.valueMember)).length > 0
        ? comboChildren.filter(ch => controlValues.includes(ch.valueMember))[0].valueMember
        : null;
    },
    getPrice(comboChildren, controlValues) {
      return comboChildren.filter(ch => controlValues.includes(ch.valueMember)).length > 0
        ? comboChildren.filter(ch => controlValues.includes(ch.valueMember))[0].value
        : null;
    },
    update(item) {
      if (!this.isLoading) {
        this.setDirty(true);
        item.isDirty = true;
        // console.log(item);
        let prices = item.children.filter(ch => ch.valueMember === item.value);
        // console.log(prices);
        if (prices.length) {
          item.price = prices[0].value;
        } else {
          item.price = null;
        }
        if (item.required && (item.value == null || item.value == '')) {
          item.isValidate = false;
        } else {
          item.isValidate = true;
        }
      }
    },
    getValue() {
      return this.categories
        .map(c => {
          return c.value;
        })
        .filter(c => c);
    },
    checkValidate() {
      let requiredItems = this.categories.filter(category => {
        return category.isValidate == false;
      });
      if (requiredItems.length) {
        for (let i = 0; i < requiredItems.length; i++) {
          requiredItems[i].isDirty = true;
        }
        return false;
      } else {
        return true;
      }
    },
    checkAllSetData() {
      //console.log(this.categories);
      if (this.categories.length) {
        if (
          this.categories.filter(category => {
            return category.not_set == true;
          }).length
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  created() {
    this.l_autoload = false;
    this.l_label = '';
    if(this.jeOlfs){
      this.l_dataId = 'liw_filip__wiz_poistenie__cb_poistenie_kasko_pripoistenia_olfs';
    }else{
      this.l_dataId = 'liw_filip__wiz_poistenie__cb_poistenie_kasko_pripoistenia';
    }
    this.l_ignoreInit = true;
  },
};
</script>
